
import { mapGetters,mapActions } from 'vuex'
import { findFaqs, buildFaqPageSchema } from '@/utils/faqSchema'

export default {
    props: {
        id: {
            default: '',
            type: String,
        },
        img: {
            default: 'https://cdn-wp.tefl.org/wp-content/uploads/2026/03/Debbie.jpg',
            type: String,
        },
        viewmore: {
          default: 'true',
          type: String
        },
        newbuttons: {
          default: 'false',
          type: String
        }
    },
    data(){
        return{
            activeQuestion: 'question_1',
        }
    },
    // Built from the slot vnodes rather than the rendered DOM, so the schema is in the
    // statically generated HTML and visible to crawlers that don't run JavaScript
    head() {
      const schema = buildFaqPageSchema(findFaqs(this.$slots.default))
      if (!schema) return {}
      return {
        script: [{ type: 'application/ld+json', json: schema }]
      }
    },
    computed: {
      ...mapGetters({
        activeModal : 'pages/getActiveModal',
      }),
    },
    methods:{
      openFrontChat() {
          if (typeof window !== 'undefined' && window.FrontChat) {
            // window.FrontChat('update', {
            //   name: this.user.name,
            //   email: this.user.email
            // })
            window.FrontChat('show')
          } else {
            console.warn('FrontChat not available yet')
          }
        },
        isActive (question) {
            return this.activeQuestion === question
        },
        setActive (question) {
            this.activeQuestion = question
            
            // Track via GTM
            this.$gtm.push({
              event: 'faq_click',
              question,
            });

            // Track via rudderstack
            // this.$rs.track("FAQ Click", {
            //   question,
            // }, {
            //   integrations: {
            //     "Klaviyo": false,
            //   },
            // })
        },
        ...mapActions({
          updateActiveModal: 'pages/updateActiveModal', // map `this.add()` to `this.$store.commit('increment')`
        }),
        updateModal(id){
          this.updateActiveModal(id)
          console.log('Active Modal: ',this.activeModal)
        }
    },
}
